import React, { useState } from "react";
import { MuiChipsInput } from 'mui-chips-input'
import { Button, Input } from "@mantine/core";

import "./queryRunner.css";
import { themeProvider } from "../../../../../style/utils";
import { queryExecutorInput, queryExecutorRequestBody, queryExecutorResponse, QueryRunnerProp } from "../../../../../../types/types";
import { useAuth } from "../../../../../../providers/AuthProvider";
import { executeQuery } from "../../../../../../services/executorService";

const QueryRunner = (props: QueryRunnerProp) => {
    const [loginInput, setloginInput] = useState<queryExecutorInput>({});
    const [queryResponse, setQueryResponse] = useState<queryExecutorResponse>();
    const [errorResponse, setErrorResponse] = useState<any>();
    const authContext = useAuth();

    const getQueryExecutionBody:()=>queryExecutorRequestBody = () => {
        const reqBody:queryExecutorRequestBody = {
            "configuration": {
                "queries": [
                    {
                        "name": "TEST",
                        "query": props.query
                    }
                ]
            },
            "executionMode": props.executionMode,
            
        };
        props.executionMode === "BATCH" && (reqBody.loginIds = loginInput.loginIds);
        props.executionMode === "SPLIT" && (reqBody.loginId = loginInput.loginId);
        return reqBody;
    }

    const runQuery = async() => {
        const queryExecutionBody = getQueryExecutionBody();
        try{
            const response = await executeQuery(queryExecutionBody,authContext)
            setQueryResponse(response);
        }
        catch(e) {
            setErrorResponse(e);
        }
    }

    const openRunSqlDisplay = () => {
        props.setSqlEditorOpened(true);
        props.setSqlRunnerOpened(false);
    }

    const updateLoginInput = (event: {
        target: { value: string };
    }) => {
        const inputData: any = {};
        inputData.loginId = event.target.value.trim();
        setloginInput(inputData);
    };

    const [chips, setChips] = React.useState<string[]>([])
    const handleChange = (newChips: string[]) => {
        setChips(newChips);
        setloginInput({ ...loginInput, loginIds: newChips })
    }

    const getStringifiedResponse = ()=>{
        return JSON.stringify(queryResponse,undefined,2);
    }
    const getStringifiedErrorResponse = ()=>{
        return JSON.stringify(errorResponse,undefined,2);
    }


    return (
        <div>
            <div className="queryRunner-heading"> Query Executor </div>
            <div className="queryRunner-container">
                {props.executionMode === "SPLIT" && <Input
                    className="queryRunner-input"
                    placeholder="Enter Login Id"
                    onChange={updateLoginInput}
                />}
                {props.executionMode === "BATCH" && <MuiChipsInput
                    value={chips}
                    onChange={handleChange}
                    label="Enter Login Ids"
                    onPointerEnterCapture={() => {}}
                    onPointerLeaveCapture={() => {}}
                />}
                <div className="queryRunner-output">
                    {queryResponse && <pre>{getStringifiedResponse()}</pre>}
                    {errorResponse && <pre>{getStringifiedErrorResponse()}</pre>}
                </div>
            </div>
            <div className="queryRunner-button-container">
                <div className="queryRunner-button">
                    <Button sx={themeProvider} color="teal" variant="outline"
                        onClick={runQuery}>
                        Run
                    </Button>
                </div>
                <div className="queryRunner-button">
                    <Button sx={themeProvider} color="teal" variant="outline"
                        onClick={openRunSqlDisplay}>
                        Edit Query
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default QueryRunner;
